export default __webpack_public_path__ + "static/media/erhardt-object.41505bd5.png";